import HeaderButtons from "components/Button/HeaderButtons";
import GenericModal from "components/Modal";
import React, { useEffect } from "react";
import apiService from "services/apiService";
import AddSettings from "./AddSettings";
import UpdateSettings from "./UpdateSettings";
import ViewDeviceSettings from "./ViewDeviceSettings";

interface DeviceSettingsProps {
  screenshotEnabled: boolean;
  deviceCheckInterval: number;
  dailyBreakLimit: number;
  sessionUploadInterval: number;
  urlSessionUploadInterval: number;
  deviceStatusUploadInterval: number;
  presenceCheckInterval: number;
  presenceUploadInterval: number;
  scheduleTrackingEnabled: boolean;
  idleThreshold: number;
  screenshotInterval: number;
  workStartTime: string;
  workEndTime: string;
  workDays: number[];
  updatedAt: string;
  dashboardEnabled?: boolean;
  screenshotQuality?: string;
  appTrackingEnabled?: boolean;
  urlTrackingEnabled?: boolean;
  presenceTrackingEnabled?: boolean;
  deviceTrackingEnabled?: boolean;
  wifiTrackingEnabled?: boolean;
  liveScreenEnabled?: boolean;
  liveScreenQuality?: string;
}

const DeviceSettings: React.FC = () => {
  const [deviceSettings, setDeviceSettings] =
    React.useState<DeviceSettingsProps | null>(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const [isAdding, setIsAdding] = React.useState(false);
  const [isEditing, setIsEditing] = React.useState(false);

  const fetchSettings = () => {
    setIsLoading(true);
    apiService
      .get(`/api/tracking-global-settings/get`)
      .then((response) => {
        console.log("Device settings:", response.data);
        if (response.status === 200) {
          setDeviceSettings(response.data);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching device settings:", error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8 px-4 md:w-full lg:w-2/3 mx-auto">
      {/* <div className=" mx-auto"> */}
      {deviceSettings ? (
        <ViewDeviceSettings
          settings={deviceSettings}
          onEdit={() => setIsEditing(true)}
        />
      ) : (
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-12 text-center pb-2">
          <svg
            className="w-16 h-16 text-gray-400 mx-auto mb-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
          </svg>
          <h3 className="text-xl font-semibold text-gray-800 dark:text-white mb-2">
            No Settings Configured
          </h3>
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            Get started by adding your tracking settings
          </p>
          <HeaderButtons onClick={() => setIsAdding(true)} variant="primary">
            <svg
              className="w-4 h-4 mr-2 inline"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 4v16m8-8H4"
              />
            </svg>
            Add Settings
          </HeaderButtons>
        </div>
      )}
      {isAdding && (
        <GenericModal
          onClose={() => setIsAdding(false)}
          isOpen={isAdding}
          size="xl"
        >
          <AddSettings
            onSuccess={() => {
              setIsAdding(false);
              fetchSettings();
            }}
          ></AddSettings>
        </GenericModal>
      )}
      {isEditing && deviceSettings && (
        <GenericModal
          onClose={() => setIsEditing(false)}
          isOpen={isEditing}
          size="xl"
        >
          <UpdateSettings
            settings={deviceSettings}
            isModal={true} // <--- ADD THIS LINE
            onSuccess={() => {
              setIsEditing(false);
              fetchSettings();
            }}
            onCancel={() => setIsEditing(false)}
          />
        </GenericModal>
      )}
      {/* </div> */}
    </div>
  );
};
export default DeviceSettings;